import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { PageHeader, GenericError } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useLocation } from 'react-router'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useCustomerTaxDocuments } from '@egw/api'
import { ListLink, ListLinkEnum } from '../../components'

export const TaxesByDate: FC = () => {
  const { t } = useTranslation('features-documents')
  const location = useLocation()

  const year = new URLSearchParams(location.search).get('year') ?? ''

  const { data, isLoading, error } = useCustomerTaxDocuments(
    { year },
    {
      enabled: year !== '',
    },
  )

  return (
    <>
      {isLoading ? (
        <div className="egw-container">
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        </div>
      ) : null}

      {!isLoading && (
        <PageHeader
          subtitle={t('tax.title')}
          title={t('tax.year_screen_title', { year })}
          backLinkUrl={WEALTH_ROUTES.DOCUMENTS.path}
        />
      )}

      {Boolean(error) && (
        <div className="egw-container pt-0">
          <GenericError errorMessage={t('common.generic_error')} />
        </div>
      )}

      {data ? (
        <div className="egw-container pt-0">
          {data.documents.length ? (
            data.documents.map((item) => (
              <ListLink key={item.name} to={item.url} title={item.name} variant={ListLinkEnum.DOWNLOAD} />
            ))
          ) : (
            <div className="bg-bglight text-body px-3 py-3.5">{t('tax.no_documents')}</div>
          )}
        </div>
      ) : null}
    </>
  )
}
